import React from 'react'
// libs
import { useQuery } from '@apollo/client/react'
// graphql
import { USERS_LOOKUP_DETAILS_QUERY } from 'graphql/user/queries'
// components
import { Input } from 'components/FormElements'
// constants
import { COUNTRIES } from 'constants/countries'
import { DATE_FORMATS } from 'constants/date'
import { USER_GENDER_OPTIONS } from 'constants/users'
// utils
import { getOptionByValue } from 'utils/form/select'
// types
import { IUsersResponse } from 'types/graphql'

interface Props {
  fields: string[]
  userId: string
}

interface Response {
  users: IUsersResponse
}

const UserDetails: React.FC<Props> = ({ fields, userId }) => {
  const { data } = useQuery<Response>(USERS_LOOKUP_DETAILS_QUERY, {
    skip: !userId,
    variables: {
      filter: {
        id: userId
      }
    }
  })

  const user = data?.users.data[0]

  if (!user) {
    return null
  }

  const worksiteNameValue = user.locations.map((item) => item.description).join(', ')
  const worksiteAddressValue = user.locations
    .filter((item) => item.geoLocation)
    .map((item) => item.geoLocation.address)
    .join('; ')

  const dateOfBirthValue = user.dateOfBirth ? DATE_FORMATS()[COUNTRIES.AU].format(new Date(user.dateOfBirth)) : ''
  const genderValue = getOptionByValue(user.gender, USER_GENDER_OPTIONS)?.label
  const positionValue = user.positions?.map((item) => item.description).join(', ')
  const reportsToValue = user.reportsTo ? `${user.reportsTo.firstName} ${user.reportsTo.lastName}` : ''

  const { eNumber, worksiteName, worksiteAddress, phone, email, dateOfBirth, gender, position, reportsTo } =
    fields.reduce<Record<string, boolean>>((acc, key) => {
      acc[key] = true
      return acc
    }, {})

  return (
    <React.Fragment key={user.id}>
      {eNumber && <Input label='E Number' disabled value={user.externalEmployeeId} />}
      {worksiteName && <Input label='Worksite Name' disabled value={worksiteNameValue} />}
      {worksiteAddress && <Input label='Worksite Address' disabled value={worksiteAddressValue} />}
      {phone && <Input label='Phone' disabled value={user.workPhone} />}
      {email && <Input label='Email' disabled value={user.email} />}
      {dateOfBirth && <Input label='Date of Birth' disabled value={dateOfBirthValue} />}
      {gender && <Input label='Gender' disabled value={genderValue} />}
      {position && <Input label='Position' disabled value={positionValue} />}
      {reportsTo && <Input label='Reports to Person' disabled value={reportsToValue} />}
    </React.Fragment>
  )
}

export default UserDetails
